
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, Vue, prop } from "vue-class-component";

class Props {
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false,
  });
}

@Options({})
export default class RelabelIcon extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }
}
